import * as RadixSlider from '@radix-ui/react-slider';
import type { SliderProps } from './Slider.types';

/**
 * Slider component for selecting a value within a range.
 */
export const Slider = ({
  onValueChange,
  onPointerUp,
  id,
  value,
  name,
  disabled = false,
  rootExtraClassNames = '',
  trackExtraClassNames = '',
  rangeExtraClassNames = '',
  thumbExtraClassNames = '',
  step,
  min = 0,
  max = 100,
  maxAccessible,
}: SliderProps) => {
  const resolvedMaxAccessible = Math.min(Math.max(maxAccessible ?? max, min), max);
  const resolvedValue = Math.min(Math.max(value, min), resolvedMaxAccessible);

  const handleValueChange = (nextValue: number[]) => {
    if (!onValueChange) return;
    const clampedValue = Math.min(Math.max(nextValue[0] ?? min, min), resolvedMaxAccessible);
    onValueChange([clampedValue]);
  };

  return (
    <RadixSlider.Root
      className={`tw:relative tw:flex tw:h-5 tw:w-full tw:touch-none tw:select-none tw:items-center ${rootExtraClassNames}`}
      defaultValue={[resolvedValue]}
      value={[resolvedValue]}
      onValueChange={handleValueChange}
      onPointerUp={(e) => onPointerUp && onPointerUp(e)}
      name={name}
      id={id}
      max={max}
      min={min}
      disabled={disabled}
      step={step}>
      <RadixSlider.Track
        className={`tw:relative tw:h-sq-5 tw:grow tw:rounded-sm tw:bg-sq-dark-gray tw:dark:bg-sq-dark-disabled-gray ${trackExtraClassNames}`}>
        <RadixSlider.Range className={`tw:absolute tw:h-full tw:rounded-full ${rangeExtraClassNames}`} />
      </RadixSlider.Track>
      <RadixSlider.Thumb
        className={`tw:block tw:h-sq-15 tw:w-sq-15 tw:rounded-full tw:bg-sq-theme-dark tw:active:bg-sq-theme-darker tw:focus:outline-none tw:focus-visible:outline-none tw:aria-disabled:bg-sq-dark-gray tw:dark:aria-disabled:bg-sq-dark-disabled-gray tw:transition tw:ease-in-out ${thumbExtraClassNames}`}
        aria-disabled={disabled}
      />
    </RadixSlider.Root>
  );
};
